// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BudgetEntityConfig__container___2MGzv{display:flex}.BudgetEntityConfig__left___2zGG3{flex:1;padding-right:35px;border-right:1px solid #c2c2c2}.BudgetEntityConfig__right___2L5IP{flex:1;padding-left:35px}.BudgetEntityConfig__header___2CVA5{font-weight:500;font-size:16px}.BudgetEntityConfig__row___x_e5H{font-size:14px;margin-bottom:10px}\n", ""]);
// Exports
exports.locals = {
	"container": "BudgetEntityConfig__container___2MGzv",
	"left": "BudgetEntityConfig__left___2zGG3",
	"right": "BudgetEntityConfig__right___2L5IP",
	"header": "BudgetEntityConfig__header___2CVA5",
	"row": "BudgetEntityConfig__row___x_e5H"
};
module.exports = exports;
